import { inject } from '@angular/core';

import { ClusterService } from '../../../core/services';
import { translateNow } from '../../../core/services/i18n/translate-now';
import type { NfDatasourceRegistry } from '../nf-datasource.service';

/**
 * Fury backend — the primary service for new features (category tree, logistic clients).
 * Base URL follows the active cluster, via ClusterService.furyBaseUrl().
 *
 * Any toolbelt schema referencing `x-datasource.service: 'fury'` resolves through this entry.
 * Existing schemas under `gateway/...` paths stay on `x-datasource.service: 'coulson'` — see
 * coulson.datasource.ts.
 */
export const furyDatasource: NfDatasourceRegistry = {
  fury: () => {
    const baseUrl = inject(ClusterService).furyBaseUrl();
    if (!baseUrl) {
      throw new Error(translateNow('common.datasource.noFuryBaseUrl'));
    }
    return baseUrl;
  },
};
